module.exports = __webpack_public_path__ + "static/media/greenhousesun.4c89bc6e.jpg";